import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  showmobile: boolean = false;

  constructor() {
    this.showmobile = window.innerWidth < 768;
    window.onresize = () => {
      this.showmobile = window.innerWidth < 768;
    }
  }

}
